import { Component, Input, OnInit } from '@angular/core';
import { RodzajProjektu } from 'src/app/modele/projekty/rodzajProjektu';

@Component({
  selector: 'app-podmenu-spis',
  templateUrl: './podmenu-spis.component.html',
  styleUrls: ['./podmenu-spis.component.css'],
})
export class PodmenuSpisComponent implements OnInit {
  @Input() czyPracownikKlienta: boolean;
  @Input() idProjektu: string;
  @Input() rodzajProjektu: RodzajProjektu;
  @Input() czyMobile: boolean;
  @Input() czyAdmin: string;
  @Input() aktywnyAdres: string;

  constructor() {}

  ngOnInit(): void {}
}
